import { FirebaseFilter } from "@snubes/snubes-types";
import { FieldPath, WhereFilterOp } from "firebase/firestore";

export function toQueryWhereArgs<T>(
  filter: FirebaseFilter<T>,
): [string | FieldPath, WhereFilterOp, unknown] {
  const [key, op, value] = filter;
  return [key, op === "search" ? "==" : op, value];
}
